import React from 'react';
const PaymentMethod = (props) => {
    var _a, _b, _c, _d, _e, _f;
    const payment = (_c = (_b = (_a = props === null || props === void 0 ? void 0 : props.order) === null || _a === void 0 ? void 0 : _a.billing) === null || _b === void 0 ? void 0 : _b.payment) === null || _c === void 0 ? void 0 : _c.selectedPaymentInstruments[0];
    if (!payment) {
        return React.createElement(React.Fragment, null);
    }
    if (props.inline) {
        return (React.createElement(React.Fragment, null, payment === null || payment === void 0 ? void 0 :
            payment.paymentMethodName,
            (payment === null || payment === void 0 ? void 0 : payment.lastFour) && React.createElement(React.Fragment, null,
                " *", payment === null || payment === void 0 ? void 0 :
                payment.lastFour)));
    }
    return (React.createElement(React.Fragment, null, (payment === null || payment === void 0 ? void 0 : payment.maskedCreditCardNumber) ? (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "card_type" },
            " *", payment === null || payment === void 0 ? void 0 :
            payment.maskedCreditCardNumber),
        React.createElement("p", null,
            (payment === null || payment === void 0 ? void 0 : payment.creditCardExpirationMonth) && (payment === null || payment === void 0 ? void 0 : payment.creditCardExpirationYear) ? `${payment === null || payment === void 0 ? void 0 : payment.creditCardExpirationMonth}/${payment === null || payment === void 0 ? void 0 : payment.creditCardExpirationYear} ` : '',
            "***"))) : (React.createElement("p", { className: "card_type" }, (_f = (_e = (_d = props.order.billing) === null || _d === void 0 ? void 0 : _d.payment) === null || _e === void 0 ? void 0 : _e.selectedPaymentInstruments[0]) === null || _f === void 0 ? void 0 : _f.paymentMethodName))));
};
export default PaymentMethod;
